import Env, {
	syncGetCurrentSettings,
} from 'src/environmentVariables/EnvironmentVariables';

export const getUrlForAccount = (account: string) => {
	const isMainnet = Env.sdkEnv === 'mainnet-beta';

	const explorerPreference = syncGetCurrentSettings()?.explorer;

	const explorerUrlPrefix =
		explorerPreference === 'xray'
			? `https://xray.helius.xyz/account/`
			: explorerPreference === 'solscan'
				? `https://solscan.io/account/`
				: explorerPreference === 'solanafm'
					? `https://solana.fm/address/`
					: `https://explorer.solana.com/address/`;

	return explorerUrlPrefix + account + `${isMainnet ? '' : '?cluster=devnet'}`;
};

export const getUrlForTx = (txSig: string) => {
	const isMainnet = Env.sdkEnv === 'mainnet-beta';

	const explorerPreference = syncGetCurrentSettings()?.explorer;

	const explorerUrlPrefix =
		explorerPreference === 'xray'
			? `https://xray.helius.xyz/tx/`
			: explorerPreference === 'solscan'
				? `https://solscan.io/tx/`
				: explorerPreference === 'solanafm'
					? `https://solana.fm/tx/`
					: `https://explorer.solana.com/tx/`;

	return explorerUrlPrefix + txSig + `${isMainnet ? '' : '?cluster=devnet'}`;
};

export const encodeQueryParams = (
	params: Record<string, string | number | boolean>
) => {
	const queryParams = Object.entries(params)
		.filter(([_key, param]) => param !== undefined)
		.map(([key, param]) => {
			return `${key}=${param}`;
		});

	const queryParamsString = `${queryParams.join('&')}`;

	return queryParamsString;
};
